import type { ContratoAplicativoModel } from "../models/contratoAplicativoModel"

export enum ContratoAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ContratoAplicativoActionModel =
    | {
          type: ContratoAplicativoActionsTypes.CARREGAR
          payload: ContratoAplicativoModel
      }
    | {
          type: ContratoAplicativoActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof ContratoAplicativoModel; valor: string | number | null }
      }
    | {
          type: ContratoAplicativoActionsTypes.RESETAR
      }
